import React from 'react';
import type { IssueTypeScheme } from '@atlassian/jira-admin-pages-issue-types-common/src/types.tsx';
import { CellWrapper } from '@atlassian/jira-admin-pages-issue-types-common/src/ui/index.tsx';
import { getRelatedSchemeUrl } from '@atlassian/jira-admin-pages-issue-types-common/src/utils.tsx';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { RelatedSchemesList } from './styled';

export type Props = {
	relatedSchemes: IssueTypeScheme[];
};

export const RelatedSchemesCell = ({ relatedSchemes = [] }: Props) => {
	if (!relatedSchemes.length) return null;

	return (
		<CellWrapper>
			<RelatedSchemesList>
				{relatedSchemes.map(({ id, name }, i) => (
					<li key={id}>
						<Link
							href={getRelatedSchemeUrl(id, name)}
							// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
							onClick={(_, analyticsEvent) => {
								fireUIAnalytics(analyticsEvent, 'link clicked', 'issueTypeScheme', {
									issueTypeSchemeId: id,
									issueTypeSchemeHasDescription: relatedSchemes[i].description !== '',
								});
							}}
						>
							{name}
						</Link>
					</li>
				))}
			</RelatedSchemesList>
		</CellWrapper>
	);
};
